document.addEventListener('turbo:load', () => {
  const dialog = document.querySelector('#shared-delete-confirm-modal');
  if (!dialog) return;
  if (dialog.dataset.bound === 'true') return;

  dialog.dataset.bound = 'true';

  const title = dialog.querySelector('[data-delete-confirm-title]');
  const message = dialog.querySelector('[data-delete-confirm-message]');
  const confirmButton = dialog.querySelector('[data-delete-confirm-confirm]');
  const cancelButtons = dialog.querySelectorAll('[data-delete-confirm-cancel]');

  let resolver = null;

  const resolveAndClose = (result) => {
    if (dialog.open) dialog.close();
    if (!resolver) return;

    const currentResolver = resolver;
    resolver = null;
    currentResolver(result);
  };

  cancelButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      resolveAndClose(false);
    });
  });

  confirmButton.addEventListener('click', (event) => {
    event.preventDefault();
    resolveAndClose(true);
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    resolveAndClose(false);
  });

  dialog.addEventListener('close', () => {
    if (!resolver) return;
    const currentResolver = resolver;
    resolver = null;
    currentResolver(false);
  });

  window.openDeleteConfirmModal = ({ titleText, messageText, confirmText } = {}) => {
    title.textContent = titleText || 'Delete item?';
    message.textContent = messageText || 'Are you sure you want to delete this item?';
    confirmButton.textContent = confirmText || 'Delete';

    dialog.showModal();

    return new Promise((resolve) => {
      resolver = resolve;
    });
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.deleteConfirmModal !== 'true') return;

    if (form.dataset.deleteConfirmAccepted === 'true') {
      form.dataset.deleteConfirmAccepted = 'false';
      return;
    }

    event.preventDefault();

    const confirmed = await window.openDeleteConfirmModal({
      titleText: form.dataset.deleteConfirmTitle,
      messageText: form.dataset.deleteConfirmMessage,
      confirmText: form.dataset.deleteConfirmButton
    });
    if (!confirmed) return;

    form.dataset.deleteConfirmAccepted = 'true';

    if (event.submitter && typeof form.requestSubmit === 'function') {
      form.requestSubmit(event.submitter);
    } else if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }, true);
});
